import Cart from './Cart.container';
export default Cart;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/index.js
// module id = 2236
// module chunks = 8